import { inject } from 'vue';

export default ()=>{ 

    const TOOL_toast = inject<INJECT_toast>('TOOL_toast')!;
    const TOOL_loading = inject<INJECT_loading>('TOOL_loading')!;
    const TOOL_httpClient = inject<INJECT_httpClient>('TOOL_httpClient')!;
    const TOOL_countryCode = inject<INJECT_countryCode>('TOOL_countryCode')!;
    const TOOL_TEXT = inject<INJECT_text>('TOOL_TEXT')!;
    
    return {TOOL_toast, TOOL_loading, TOOL_httpClient, TOOL_countryCode, TOOL_TEXT};
};